import { useTheme } from "@emotion/react";
import {
  Add,
  AssessmentOutlined,
  ClearOutlined,
  DeleteOutlineOutlined,
  ListAltOutlined,
  ModeEditOutlined,
  MoreVertOutlined,
  PeopleAltOutlined,
  SpeakerNotesOffOutlined,
  SpeakerNotesOutlined,
  Star,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Snackbar,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import { useState } from "react";
import dayjs from "dayjs";
import CardAllAnswers from "../forms/cardAllAnswers";
import StarRatingChart from "../forms/StartRatingChart";
import MetricCard from "../forms/metricCard";
import SelectionChart from "../forms/selectionChart";
import CommentsSection from "../forms/commentsSections/commentsSections";
import SuggestionDetailsModal from "../forms/suggestionDetailsModal";
import api from "../../services/api";

export default function CardForm(params) {
  const {
    form,
    setSelectedForm = () => {},
    setOpenDeleteModal = () => {},
    setOpenUpdateStatus = () => {},
    handleOpenEdit = () => {},
    isSuggestion = false,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataAnaliseAnswer, setDataAnaliseAnswer] = useState(null);
  const [openDetails, setOpenDetails] = useState(null);
  const [snackbar, setSnackbar] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setSelectedForm(form);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseDetails = () => {
    setDataAnaliseAnswer({});
    setOpenDetails(false);
  };

  const getDataFormAnswers = async () => {
    setLoading(true);
    setOpenDetails(true);
    try {
      const endpoint = isSuggestion
        ? "/interno/get/suggestionFormAnswers"
        : "/interno/getAllAnswer";
      const response = await api.post(endpoint, {
        formId: form?.id,
      });

      setDataAnaliseAnswer(response?.data);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao buscar métricas do formulário.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const status = {
    true: {
      label: "Ativo",
      colorChip: theme.palette.colors.green.medium,
      menuItem: (
        <MenuItem
          onClick={() => {
            /*     updateStatusForm(form?.id, false); */
            setOpenUpdateStatus(true);
            handleClose();
          }}
        >
          {" "}
          <Box sx={{ display: "flex", gap: 1 }}>
            <SpeakerNotesOffOutlined /> Desativar{" "}
          </Box>
        </MenuItem>
      ),
    },
    false: {
      label: "Inativo",
      colorChip: theme.palette.colors.gray.medium,
      menuItem: (
        <MenuItem
          onClick={() => {
            /*  updateStatusForm(form?.id, true); */
            setOpenUpdateStatus(true);
            handleClose();
          }}
        >
          {" "}
          <Box sx={{ display: "flex", gap: 1 }}>
            <SpeakerNotesOutlined /> Ativar{" "}
          </Box>
        </MenuItem>
      ),
    },
  };
  return (
    <Paper variant="outlined" sx={styles.paperContainer}>
      <Box sx={styles.boxContainer}>
        <Box sx={styles.containerTitle}>
          <Box sx={styles.boxIcon}>
            <ListAltOutlined sx={{ color: theme.palette.white.main }} />
          </Box>
          <Typography sx={styles.title}>
            {form?.title || "Título do Formulário"}
          </Typography>
        </Box>
        <Box sx={styles.containerMore}>
          <IconButton onClick={handleClick}>
            <MoreVertOutlined />
          </IconButton>
        </Box>
      </Box>
      <Divider />

      <Box sx={styles.boxBody}>
        <Box>
          <Typography sx={styles.titleDescription}>
            Perguntas: {form?.questions?.length || 0}
          </Typography>
          <Typography sx={styles.titleDescription}>
            Criado em: {dayjs(form?.createAt).format("DD/MM/YYYY")}
          </Typography>
        </Box>
        <Box>
          <Chip
            label={status[form?.status]?.label}
            size="small"
            sx={{
              ...styles.chip,
              backgroundColor: status[form?.status]?.colorChip,
            }}
          />
        </Box>
      </Box>

      <Box sx={styles.containerButton}>
        <Button
          sx={styles.buttonDetails}
          startIcon={<VisibilityOutlined />}
          variant="outlined"
          size="small"
          onClick={() => getDataFormAnswers()}
        >
          Detalhes
        </Button>
      </Box>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {status[form?.status]?.menuItem}
        <MenuItem
          onClick={() => {
            handleClose();
            handleOpenEdit();
          }}
        >
          <Box sx={styles.containerMenuItem}>
            <ModeEditOutlined /> Editar
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setOpenDeleteModal(true);
          }}
        >
          <Box sx={{ ...styles.containerMenuItem, color: "error.main" }}>
            <DeleteOutlineOutlined color="error" /> Excluir
          </Box>
        </MenuItem>
      </Menu>

      {isSuggestion ? (
        <SuggestionDetailsModal
          open={openDetails}
          handleClose={handleCloseDetails}
          data={dataAnaliseAnswer}
          form={form}
          loading={loading}
        />
      ) : (
        <Modal
          open={openDetails}
          onClose={() => {
            handleCloseDetails();
          }}
        >
        {!loading ? (
          <Box sx={styles.boxModal}>
            <IconButton onClick={handleCloseDetails} sx={styles.iconButton}>
              <ClearOutlined />
            </IconButton>
            <Grid container columns={{ xs: 4, md: 4 }}>
              <Grid xs={4} md={2} lg={2} xl={2} xxl={2}>
                <CardAllAnswers
                  colorCard={theme.palette.cardTrafficData.paperColor.statusUp}
                  icon={PeopleAltOutlined}
                  colorIcon={theme.palette.colors.green.light}
                  title="Formulários respondidos"
                  descricao="Respostas enviadas"
                  value={dataAnaliseAnswer?.analiseAnswers?.totalRespostas}
                />
              </Grid>
              <Grid xs={4} md={2} lg={2} xl={2} xxl={2}>
                <CardAllAnswers
                  colorCard={theme.palette.gradient.cardWhiteForms}
                  colorIcon={theme.palette.colors.purple.medium}
                  icon={AssessmentOutlined}
                  /* value={"85,5%"} */
                  value={dataAnaliseAnswer?.analiseAnswers?.totalNaoRespondida}
                  title={"Formulários em branco"}
                  descricao="Enviaram sem resposta"
                />
              </Grid>
            </Grid>
            <Box sx={styles.boxBodyModal}>
              {dataAnaliseAnswer?.dataAanaliseForPosition?.map(
                (question, index) => (
                  <Paper key={index} variant="outlined" sx={styles.paperBody}>
                    <Typography
                      variant="h6"
                      sx={{ mb: 3, fontWeight: 600, textAlign: "justify" }}
                    >
                      {index + 1} - {question?.question}
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      sx={{ mb: 3 }}
                      alignItems="center"
                    >
                      {question?.type === 0 && (
                        <>
                          <Grid item xs={12} md={4}>
                            <Box sx={{ height: "160px" }}>
                              <MetricCard
                                title="Avaliação Média"
                                value={question?.media || 0}
                                subtitle="De 5 estrelas"
                                icon={<Star />}
                                iconColor={theme.palette.white.main}
                                gradient={
                                  theme.palette.cardTrafficData.paperColor
                                    .inputData
                                }
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <Paper
                              variant="outlined"
                              sx={{ borderRadius: "16px" }}
                            >
                              <StarRatingChart
                                mainLineColor={
                                  theme.palette.mode == "dark"
                                    ? theme.palette.white.main
                                    : theme.palette.colors.gray.darker
                                }
                                data={question?.dataAnalise || []}
                              />
                            </Paper>
                          </Grid>
                        </>
                      )}
                      {question?.type === 1 && (
                        <Box sx={{ width: "100%" }}>
                          <CommentsSection comments={question?.dataAnalise} />
                        </Box>
                      )}
                      {question?.type === 2 && (
                        <Box sx={{ width: "100%" }}>
                          <SelectionChart data={question?.dataAnalise || []} />
                        </Box>
                      )}
                    </Grid>
                  </Paper>
                ),
              )}
            </Box>
          </Box>
        ) : (
          <Box sx={{ ...styles.boxModal, height: "600px" }}>
            <Box sx={styles.containerLoading}>
              <CircularProgress />
            </Box>
          </Box>
        )}
      </Modal>
      )}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Paper>
  );
}
